<template>
  <div v-if="loading">
    <loadingAnimation />
  </div>
  <div class="col" v-else-if="error">
    <navError></navError>
  </div>
  <div v-else id="top-navigation" class="top-nav">
    <div class="container-fluid px-0">
      <div class="row top-row g-0 justify-content-between align-items-center">
        <div class="col mx-2">
          <!--======= NAVBAR TOGGLER =======-->
          <button
            class="navbar-toggler"
            type="button"
            id="navTog"
            v-on:click="navBtnToggle()"
          >
            <span class="line-1"></span>
            <span class="line-2"></span>
            <span class="line-3"></span>
          </button>
          <!--======= Desktop Search Bar =======-->
          <form
            action="/search"
            method="get"
            role="search"
            class="hidden-mobile-nav nav-search search-open mx-2"
          >
            <div class="search-toggler">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xml:space="preserve"
                baseProfile="tiny"
                class="modal__toggle-open icon icon-search"
                viewBox="0 0 200 200"
                id="icon-search"
              >
                <path
                  fill-rule="evenodd"
                  d="m168.76 158.74-32.09-32.1a60.21 60.21 0 1 0-10.02 10.02l32.1 32.09a7.08 7.08 0 1 0 10.01-10.01zm-46.49-37.15-.36.32c-.11.11-.22.23-.32.36a46.04 46.04 0 1 1 .68-.68z"
                ></path>
              </svg>
            </div>
            <!-- .search-toggler -->
            <div class="search-field">
              <input
                type="search"
                name="q"
                class="form-control fast-autocomplete fast-autocomplete-input"
                id="search-new-header"
                value=""
                placeholder="Search"
                aria-label="Search and use arrows or TAB to navigate results"
                autocomplete="off"
                data-autocomplete-id="fast-autocomplete-1236"
                autocorrect="off"
                autocapitalize="off"
                aria-autocomplete="list"
              />
            </div>
            <!-- .search-field -->
          </form>
        </div>
        <!--.col-->
        <!--======= NAVBAR BRAND =======-->
        <div class="col">
          <a class="navbar-brand" href="/">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 326.43">
              <path
                d="M160.01 105.84c-9.29-5.96-11.28-21.12-11.28-21.12a273.86 273.86 0 0 1-37.87-15.7c-8.45-5.66-10.44-9.04-23.21-12.72 27.33-22.91 17.44-60.57 14.71-47.46-2.14 10.34-21.67 34.34-30.11 44.47-.55 0-1.84.35-2.39.35C90.09 29.32 81.49-7.21 79.31 1.24c-3.48 13.52-37.57 66.24-37.57 66.24S21.76 85.42 19.63 90.69c0 0 4.72-1.14 7.26-.94 0 0-18.49 33.54-18.83 48.45 0 0 3.03-3.28 4.82-4.47-.1 4.52 4.97 35.48 6.96 47.41 2.29 13.76 2.24 28.37-11.73 33.14a22.66 22.66 0 0 1-8.1 1.19c21.96 29.32 68.03 110.96 68.03 110.96 19.68-13.91 32.1-33.09 35.43-42.44.5.05 6.31 2.63 6.31 2.63 11.83-23.16 6.96-52.28 3.18-59.68 5.91 3.48 8.05 2.98 8.05 2.98-.65-6.06-11.08-31.21-11.08-31.21 6.86.89 8.75-1.39 8.75-1.39-12.82-8.65-20.03-32.45-20.03-32.45 2.98 1.74 4.47 2.34 10.24 5.52-9.74-19.48-24.95-38.26-24.95-38.26 8.25 2.48 20.32-6.26 25.69-8.89a82.7 82.7 0 0 1 12.87-4.77c5.17.15 11.58 4.67 16.35 4.32 5.86-.4 18.09-13.47 19.73-13.37 1.79.1 2.98-2.58 1.44-3.58ZM89.55 79.85h-.2c-.84.2-1.69.55-2.48.94-.55.25-1.04.5-1.54.7a13.03 13.03 0 0 1-6.96 1.05c-5.57-.7-9.89-5.22-12.62-10.83a28 28 0 0 0 5.81.84c4.72.3 10.83.25 14.76-.4.35-.05.75-.05 1.09-.05 5.17.25 6.91 8.75 6.91 8.75s-1.59-1.64-4.77-.99ZM969.59 142.12l-22.96-5.42v15.41h22.96v-9.99zM770.47 207.81c0-3.08-.1-6.46-.25-10.34a56.13 56.13 0 0 0-1.49-10.73 37.15 37.15 0 0 0-4.07-10.09 28.54 28.54 0 0 0-7.85-8.5c-3.33-2.43-7.6-4.32-12.67-5.71s-11.23-2.09-18.49-2.09c-4.67-.05-9.39.35-14.01 1.09-3.73.55-7.4 1.34-11.03 2.34a65.02 65.02 0 0 0-10.14 3.33l-.75.3-4.27 23.95 18.24 3.48 2.48-13.76a77.64 77.64 0 0 1 20.13-2.48c4.17 0 7.65.45 10.44 1.29s4.92 1.94 6.51 3.33a12.73 12.73 0 0 1 3.53 4.72c.83 1.88 1.4 3.87 1.69 5.91.35 2.09.5 4.22.45 6.36-.05 2.24-.05 4.37-.05 6.41v.3l-29.32-.25c-5.32 0-10.63.6-15.85 1.79a38.38 38.38 0 0 0-13.12 5.76 27.81 27.81 0 0 0-8.94 10.29c-2.14 4.17-3.23 9.19-3.13 14.96a31.42 31.42 0 0 0 3.03 13.27 32.24 32.24 0 0 0 8.55 10.63 40.24 40.24 0 0 0 13.42 6.96 60.56 60.56 0 0 0 17.69 2.43c7.21 0 13.81-1.09 19.63-3.28a33.5 33.5 0 0 0 8.25-5.07l.1 4.87h21.62l-.3-61.47Zm-21.42 38.46a69.17 69.17 0 0 1-3.83 2.48 32.85 32.85 0 0 1-5.96 2.83 53.6 53.6 0 0 1-7.75 2.14c-5.57 1.09-12.17 1.24-17.84-.15a20.18 20.18 0 0 1-6.81-2.83 15.25 15.25 0 0 1-4.52-4.77 12.53 12.53 0 0 1-1.64-6.66c0-3.23.55-5.81 1.59-7.7a9.54 9.54 0 0 1 4.12-4.17 17.32 17.32 0 0 1 6.21-1.99c2.53-.35 5.07-.5 7.65-.5l28.77.25v21.07ZM862.65 217.6l30.07-35.88h18.73v-17.84h-50.84v17.84h8.9l-19.03 23.16-21.87-23.16h10.93v-17.84H782.3v17.84h18.68l32.5 34.39-29.61 35.33H782.3v17.84h53.62v-17.84h-8.7l18.64-22.11 21.11 22.11h-8.64v17.84h57.44v-17.84h-20.92l-32.2-33.84zM969.49 163.88H928v17.84h19.77v69.72H928v17.84h61.32v-17.84h-19.83v-87.56zM666.17 190.62a44.48 44.48 0 0 0-27.53-26.88 64.98 64.98 0 0 0-21.17-3.38c-3.18 0-6.36.3-9.49.89-2.98.6-5.86 1.39-8.75 2.39a60.2 60.2 0 0 0-7.8 3.38 69.9 69.9 0 0 0-5.86 3.38l-32.75-11.23-5.57 17.74 22.71 7.55v116.53h-20.03v17.84h61.72v-17.84h-20.03v-31.65a90.4 90.4 0 0 0 10.04 2.29c4.87.84 9.84 1.24 14.81 1.19 7.9 0 15.21-1.49 21.72-4.37a48.99 48.99 0 0 0 16.94-12.32 55.35 55.35 0 0 0 10.93-18.78c2.58-7.21 3.88-15.31 3.88-24s-1.24-16.15-3.78-22.71Zm-18.24 22.76a66.66 66.66 0 0 1-2.04 16.85 39.41 39.41 0 0 1-6.01 13.02 27.16 27.16 0 0 1-9.89 8.35c-3.93 1.99-8.55 2.98-13.71 2.98h-.35a56.47 56.47 0 0 1-18.63-2.98 28.75 28.75 0 0 1-5.66-2.43v-62.36a36.41 36.41 0 0 1 6.36-3.83 51.56 51.56 0 0 1 8.2-2.93 45.47 45.47 0 0 1 10.98-1.34h.05c20.62 0 30.71 11.33 30.71 34.68ZM994.83 168.51c0-1.99-1.59-3.03-3.73-3.03h-4.37l.05 9.64h1.84v-3.33h2.04l2.29 3.33h2.24l-2.58-3.68a2.9 2.9 0 0 0 2.24-2.93Zm-3.93 1.79h-2.34v-3.18h2.34c1.24 0 1.94.55 1.94 1.59 0 .94-.7 1.59-1.94 1.59Z"
                class="logo"
              />
              <path
                d="M990.46 160.95a9.53 9.53 0 0 0-9.49 9.54v.05a9.5 9.5 0 0 0 9.54 9.49 9.53 9.53 0 0 0 9.49-9.54v-.05a9.53 9.53 0 0 0-9.54-9.49Zm8.4 9.54a8.44 8.44 0 0 1-16.85.05v-.05a8.44 8.44 0 0 1 16.85-.05v.05ZM350.97 175.51a47.8 47.8 0 0 0-17.24-11.18c-6.66-2.58-14.11-3.88-22.21-3.88a58.56 58.56 0 0 0-21.67 3.88 48.77 48.77 0 0 0-17.04 11.18c-4.72 4.77-8.4 10.78-11.03 17.74s-3.88 14.91-3.88 23.55 1.29 16.55 3.88 23.5 6.31 12.92 11.03 17.69a48.64 48.64 0 0 0 17.04 11.13 58.68 58.68 0 0 0 21.67 3.83c8.1 0 15.55-1.29 22.21-3.83 6.5-2.4 12.38-6.2 17.24-11.13a50.28 50.28 0 0 0 11.13-17.69c2.58-6.91 3.93-14.81 3.93-23.5s-1.34-16.7-3.93-23.6a51.1 51.1 0 0 0-11.13-17.69Zm-15.21 69.37c-5.22 6.41-13.37 9.69-24.05 9.69s-18.44-3.23-23.65-9.69c-5.27-6.61-7.95-16.05-7.95-28.08s2.68-21.62 7.95-28.23 13.22-9.84 23.65-9.84 18.73 3.28 24 9.89c5.37 6.61 8.1 16.1 8.1 28.18s-2.73 21.57-8.05 28.08ZM240.51 244.53a54.85 54.85 0 0 1-9.24 4.97 65.1 65.1 0 0 1-9.99 3.53 46.82 46.82 0 0 1-12.03 1.49c-10.49 0-18.44-3.28-23.65-9.79-5.32-6.66-8-16.15-8-28.23s2.68-21.57 8-28.13c5.22-6.41 13.17-9.69 23.65-9.69 5.42 0 9.64.35 12.62 1.09 2.68.75 4.22 1.19 5.12 1.49l3.18 17.29 18.29-4.03-5.42-27.98-.7-.35a53.96 53.96 0 0 0-8.3-2.88 91.18 91.18 0 0 0-10.29-1.99c-4.87-.7-9.74-.99-14.66-.94a60.55 60.55 0 0 0-21.62 3.83 47.96 47.96 0 0 0-17.04 11.13 50.03 50.03 0 0 0-11.03 17.69c-2.58 6.86-3.88 14.81-3.88 23.45s1.29 16.6 3.88 23.5a50.13 50.13 0 0 0 11.03 17.79 48.09 48.09 0 0 0 17.04 11.18 58.51 58.51 0 0 0 21.62 3.93c5.42.05 10.78-.75 16-2.24a87.17 87.17 0 0 0 13.07-4.82 66.32 66.32 0 0 0 8.89-4.82c3.73-2.48 3.88-2.63 3.88-3.53v-.45l-9.19-13.37-1.24.84ZM436.29 253.83c-.15 0-.45 0-3.83.6-2.53.35-5.12.55-7.7.55-4.37-.3-7.7-1.54-9.94-3.73a19.17 19.17 0 0 1-4.87-8.2 42.35 42.35 0 0 1-1.74-10.78c-.1-3.88-.15-7.4-.15-10.58v-40h29.82v-17.84h-29.82v-25.39l-21.37 5.02v20.42h-19.78v17.84h19.78v50.44c0 6.71.84 12.62 2.53 17.64a34.75 34.75 0 0 0 7.35 12.77 30.58 30.58 0 0 0 11.78 7.75 44.83 44.83 0 0 0 15.35 2.53c2.24 0 4.37-.15 6.56-.35 1.79-.2 3.58-.55 5.32-.99a33.9 33.9 0 0 0 4.87-1.44l1.29-.5-4.27-15.75h-1.19ZM545.87 193.2a51.54 51.54 0 0 0-11.08-17.74 49.29 49.29 0 0 0-17.29-11.23c-6.71-2.53-14.16-3.83-22.21-3.83s-15.11 1.29-21.62 3.88a48.77 48.77 0 0 0-17.04 11.18 49.5 49.5 0 0 0-11.08 17.79c-2.58 6.96-3.83 14.91-3.83 23.55s1.29 16.55 3.83 23.5a49.52 49.52 0 0 0 11.08 17.69 48.64 48.64 0 0 0 17.04 11.13 60.73 60.73 0 0 0 21.62 3.83 63.73 63.73 0 0 0 22.21-3.83 48.3 48.3 0 0 0 17.29-11.13 50.88 50.88 0 0 0 11.08-17.69c2.63-6.96 3.98-14.86 3.98-23.5s-1.29-16.65-3.98-23.6Zm-26.29 51.63c-5.32 6.46-13.17 9.69-24.05 9.69-10.63 0-18.39-3.18-23.65-9.69-5.32-6.56-8-16.05-8-28.08s2.68-21.62 8-28.23 13.07-9.84 23.65-9.84 18.68 3.33 24 9.84c5.42 6.66 8.1 16.15 8.1 28.23s-2.73 21.62-8.05 28.08Z"
                class="logo"
              />
            </svg>
          </a>
        </div>
        <!--.col-->
        <div class="col mx-2">
          <!--======= NAVBAR SECONDARY G4G =======-->
          <nav
            class="navbar-secondary"
            v-bind:class="{ open: isDropOpen }"
            id="nav-sec"
          >
            <ul class="navright hidden-mobile-nav level-1">
              <li v-for="g4gLink in gear4good">
                <a
                  href="#"
                  ref="dropper"
                  :attr-drop="'gdrop-' + g4gLink.position"
                  v-bind:class="{ open: isDropOpen }"
                  v-on:click="isDropOpen = !isDropOpen"
                  @click="navSwitch(), stops($event)"
                  >{{ g4gLink.linkTitle }}</a
                >
              </li>
            </ul>
            <!-- LEVEL 2 -->
            <div
              class="level-2 hidden-mobile-nav"
              v-bind:class="{ dropOpen: isDropOpen }"
            >
              <template v-for="g4gLink in gear4good">
                <!-- Dropdown -->
                <div
                  class="drop-menu"
                  v-if="g4gLink.level2Links != ''"
                  :key="g4gLink.linkId"
                  v-bind:class="{ active: isDropOpen }"
                  :id="'gdrop-' + g4gLink.position"
                >
                  <a href="#" class="drop-back">{{ g4gLink.linkTitle }}</a>
                  <div class="menu-links">
                    <template v-for="glevel2Link in g4gLink.level2Links">
                      <div
                        class="sub"
                        :id="'gsub-' + g4gLink.position"
                        v-if="glevel2Link.linkType != 'navTile'"
                      >
                        <h3 class="title has-sub">
                          <a v-if="glevel2Link.url" :href="glevel2Link.url">{{
                            glevel2Link.linkTitle
                          }}</a>
                          <span :attr-sub="'gsub-' + g4gLink.position">{{
                            glevel2Link.linkTitle
                          }}</span>
                        </h3>
                        <!-- LEVEL 3 -->
                        <ul class="list">
                          <li
                            v-for="glevel3Link in glevel2Link.level3Links"
                            class=""
                          >
                            <a :href="glevel3Link.url">{{
                              glevel3Link.linkTitle
                            }}</a>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </div>
                  <!-- .menu-links -->
                  <div class="menu-boxes">
                    <template v-for="glevel2Link in g4gLink.level2Links">
                      <a
                        v-if="glevel2Link.linkType == 'navTile'"
                        :href="glevel2Link.url"
                        class="menu-box"
                      >
                        <img
                          v-if="glevel2Link.imgUrl"
                          :src="
                            glevel2Link.imgUrl.url.replace(
                              'upload',
                              'upload/w_400/f_auto,q_auto'
                            )
                          "
                          :alt="glevel2Link.imgUrl.filename"
                          class="img-fluid"
                        />
                        <h1 class="display-7">
                          {{ glevel2Link.linkTitle }}
                        </h1>
                      </a>
                      <!-- .menu-box -->
                    </template>
                  </div>
                  <!-- .menu-boxes -->
                </div>
                <!-- .drop-menu -->
              </template>
            </div>
            <!-- .level-2 -->
            <ul class="nav-icons">
              <li class="hidden-mobile-nav">
                <a href="https://help.cotopaxi.com/">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.875"
                      y="0.875"
                      width="18.25"
                      height="18.25"
                      rx="9.125"
                      stroke="#25282A"
                      stroke-width="1.75"
                    />
                    <path
                      d="M9.32906 12.752H11.1211V12.4C11.1211 11.456 11.7131 10.992 12.3531 10.464C13.1211 9.856 13.9531 9.184 13.9531 7.584C13.9531 5.424 12.3051 4.16 10.3691 4.16C8.52906 4.16 6.80106 5.328 6.73706 7.536H8.41706C8.46506 6.432 9.36106 5.808 10.3691 5.808C11.4091 5.808 12.2251 6.496 12.2251 7.584C12.2251 8.576 11.6171 9.056 10.9451 9.552C10.1771 10.16 9.32906 10.8 9.32906 12.4V12.752ZM9.24906 16H11.2011V13.968H9.24906V16Z"
                      fill="#25282A"
                    />
                  </svg>
                </a>
              </li>
              <li class="hidden-mobile-nav">
                <a href="https://account.cotopaxi.com/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xml:space="preserve"
                    viewBox="0 0 200 200"
                  >
                    <g fill-rule="evenodd" clip-rule="evenodd">
                      <path
                        d="M100 102a35.42 35.42 0 1 0 0-70.84 35.42 35.42 0 0 0 0 70.84zm0-56.67a21.24 21.24 0 1 1 .01 42.49 21.24 21.24 0 0 1-.01-42.49zM128.33 116.17H71.67a35.42 35.42 0 0 0-35.42 35.42v14.17a7.08 7.08 0 0 0 14.16 0v-14.17a21.24 21.24 0 0 1 21.25-21.25h56.67a21.24 21.24 0 0 1 21.25 21.25v14.17a7.08 7.08 0 0 0 14.16 0v-14.17a35.4 35.4 0 0 0-35.41-35.42z"
                      />
                    </g>
                  </svg>
                </a>
              </li>
              <li class="hidden-mobile-nav header-flg">
                <div class="ctpx-btn">
                  <button
                    id="flag_toggleh"
                    v-on:click="isFlagOpen = !isFlagOpen"
                  >
                    <svg
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 22 22"
                      style="enable-background: new 0 0 22 22"
                      xml:space="preserve"
                    >
                      <path
                        class="st0"
                        d="M10.9,0.3C5,0.3,0.2,5.1,0.2,11S5,21.7,10.9,21.7c5.9,0,10.7-4.8,10.7-10.7S16.8,0.3,10.9,0.3z M20,10h-2.9
	c-0.2-2.7-1.4-5.3-3.6-7.8C17,3.3,19.6,6.3,20,10z M11.7,2.4c2.4,2.4,3.8,5,4,7.6h-4V2.4z M10.2,11.5v8.2c-2.6-2.6-3.9-5.4-4-8.2
	H10.2z M6.2,10c0.4-3.6,2.8-6.4,4-7.7V10H6.2z M11.7,11.5h4c-0.3,3.8-2.7,6.9-4,8.2V11.5z M8.2,2.3C6.8,3.9,5,6.6,4.7,10H1.8
	C2.2,6.3,4.8,3.3,8.2,2.3z M1.8,11.5h2.9c0.1,2.9,1.3,5.6,3.5,8.2C4.6,18.6,2,15.4,1.8,11.5z M13.7,19.8c1.5-1.8,3.3-4.6,3.5-8.2H20
	C19.8,15.4,17.2,18.6,13.7,19.8z"
                      />
                    </svg>
                  </button>
                </div>
                <div id="toggle_flgh" v-bind:class="{ open: isFlagOpen }">
                  <ul>
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://www.cotopaxi.com.au"
                        target="_blank"
                        ><img
                          src="https://cdn.shopify.com/s/files/1/0281/7544/files/au.svg"
                          alt="Australia"
                          width="25"
                        />
                        Australia</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://eu.cotopaxi.com/"
                        target="_blank"
                        ><img
                          src="https://cdn.shopify.com/s/files/1/0281/7544/files/eu.svg"
                          alt="European Union"
                          width="25"
                        />
                        European Union</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://cotopaxi.jp/"
                        target="_blank"
                        ><img
                          src="https://cdn.shopify.com/s/files/1/0281/7544/files/jp.svg"
                          alt="Japan"
                          class="jp"
                          width="25"
                        />
                        Japan</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://www.cotopaxi.co.nz/"
                        target="_blank"
                        ><img
                          src="https://cdn.shopify.com/s/files/1/0281/7544/files/nz.svg"
                          alt="New Zealand"
                          width="25"
                        />
                        New Zealand</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://uk.cotopaxi.com/"
                        target="_blank"
                        ><img
                          src="https://cdn.shopify.com/s/files/1/0281/7544/files/gb.svg"
                          alt="United Kingdom"
                          width="25"
                        />
                        United Kingdom</a
                      >
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <button
                  v-on:click="cartToggle()"
                  class="cart"
                  data-cart-view="data-cart-view"
                  aria-label="Open Side Cart"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    xml:space="preserve"
                  >
                    <path
                      d="M20.5 24c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1 3.1 1.4 3.1 3.1-1.4 3.1-3.1 3.1zm0-4.2c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1-.5-1.1-1.1-1.1zM9.9 24c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1s3.1 1.4 3.1 3.1S11.6 24 9.9 24zm0-4.2c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zm-.7-4.7c-.9 0-1.7-.5-2.1-1.3l-3.4-8c0-.3-.3-.4-.5-.4H0v-2h3.2c.9 0 1.9.7 2.3 1.5l3.4 8c0 .1.2.2.3.1l12.6-2.4c.1 0 .2-.1.2-.2V6.5h2v3.9c0 1-.8 2-1.8 2.2L9.6 15c-.1.1-.2.1-.4.1z"
                    />
                  </svg>
                  <span
                    id="CartCount"
                    class="cart-count"
                    rv-show="cart.item_count | gt 0"
                    ><span rv-text="cart.item_count"></span
                  ></span>
                </button>
              </li>
            </ul>
            <!-- .nav-icons -->
          </nav>
          <!-- .navbar-secondary -->
        </div>
        <!--.col-->
      </div>
      <div class="row">
        <div class="col">
          <form
            action="/search"
            method="get"
            role="search"
            class="input-group mobile-search"
          >
            <button
              class="btn btn-search"
              type="submit"
              aria-label="Search"
              id="mobileSearch"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xml:space="preserve"
                baseProfile="tiny"
                class="modal__toggle-open icon icon-search"
                viewBox="0 0 200 200"
                id="icon-search"
              >
                <path
                  fill-rule="evenodd"
                  d="m168.76 158.74-32.09-32.1a60.21 60.21 0 1 0-10.02 10.02l32.1 32.09a7.08 7.08 0 1 0 10.01-10.01zm-46.49-37.15-.36.32c-.11.11-.22.23-.32.36a46.04 46.04 0 1 1 .68-.68z"
                ></path>
              </svg>
            </button>
            <input
              type="search"
              name="q"
              id="Search-new-header"
              value=""
              class="form-control fast-autocomplete fast-autocomplete-input"
              placeholder="Search"
              aria-describedby="mobileSearch"
              aria-label="Search and use arrows or TAB to navigate results"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              aria-autocomplete="list"
            />
          </form>
        </div>
        <!--.col-->
      </div>
      <!--.row-->
      <div class="row justify-content-center align-items-center g-0">
        <div class="col g-0">
          <!--======= NAVBAR CUSTOM =======-->
          <nav class="navbar-custom">
            <!-- LEVEL 1 -->
            <ul class="level-1">
              <!--Gear for Good Mobile -->
              <li
                v-for="g4gLink in gear4good"
                :class="g4gLink.textClass"
                class="d-md-block d-lg-none"
              >
                <a
                  href="#"
                  ref="dropper"
                  class="dropper"
                  @click="openMenuBar($event)"
                  :data-drop="'drop-' + g4gLink.position"
                  >{{ g4gLink.linkTitle }}</a
                >
              </li>
              <!--Gear for Good Mobile -->
              <li v-for="navLink in navie" :class="navLink.textClass">
                <!-- has children -->
                <a
                  v-if="navLink.level2Links != ''"
                  href="#"
                  ref="dropper"
                  class="dropper"
                  @click="openMenuBar($event)"
                  :data-drop="'drop-' + navLink.position"
                >
                  {{ navLink.linkTitle }}
                </a>
                <!-- has no children -->
                <a v-else :href="navLink.url" class="non-dropper">
                  {{ navLink.linkTitle }}
                </a>
              </li>
            </ul>
            <!-- .level-1 -->
            <!-- LEVEL 2 -->
            <div class="level-2">
              <!--Gear for Good Mobile -->
              <template v-for="g4gLink in gear4good">
                <!-- Dropdown -->
                <div
                  class="drop-menu"
                  v-if="g4gLink.level2Links != ''"
                  :key="g4gLink.linkId"
                  :id="'drop-' + g4gLink.position"
                >
                  <a href="#" class="drop-back" v-on:click="dropBack()">{{
                    g4gLink.linkTitle
                  }}</a>
                  <div class="menu-links">
                    <template v-for="glevel2Link in g4gLink.level2Links">
                      <div
                        class="sub"
                        :id="'sub-' + g4gLink.linkId"
                        v-if="glevel2Link.linkType != 'navTile'"
                      >
                        <h3 class="title has-sub">
                          <a v-if="glevel2Link.url" :href="glevel2Link.url">{{
                            glevel2Link.linkTitle
                          }}</a>
                          <span
                            v-on:click="subOpen($event)"
                            :data-sub="'sub-' + g4gLink.linkId"
                            >{{ glevel2Link.linkTitle }}</span
                          >
                        </h3>
                        <!-- LEVEL 3 -->
                        <ul class="list">
                          <li
                            v-for="glevel3Link in glevel2Link.level3Links"
                            class=""
                          >
                            <a :href="glevel3Link.url">{{
                              glevel3Link.linkTitle
                            }}</a>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </div>
                  <!-- .menu-links -->
                  <div class="menu-boxes">
                    <template v-for="glevel2Link in g4gLink.level2Links">
                      <a
                        v-if="glevel2Link.linkType == 'navTile'"
                        :href="glevel2Link.url"
                        class="menu-box"
                      >
                        <img
                          v-if="glevel2Link.imgUrl"
                          :src="
                            glevel2Link.imgUrl.url.replace(
                              'upload',
                              'upload/w_400/f_auto,q_auto'
                            )
                          "
                          :alt="glevel2Link.imgUrl.filename"
                          class="img-fluid"
                        />
                        <h1 class="display-7">
                          {{ glevel2Link.linkTitle }}
                        </h1>
                      </a>
                      <!-- .menu-box -->
                    </template>
                  </div>
                  <!-- .menu-boxes -->
                </div>
                <!-- .drop-menu -->
              </template>
              <!--Gear for Good Mobile -->
              <template v-for="navLink in navie">
                <!-- Dropdown -->
                <div
                  class="drop-menu"
                  v-if="navLink.level2Links != ''"
                  :key="navLink.linkId"
                  :id="'drop-' + navLink.position"
                >
                  <a href="#" class="drop-back" v-on:click="dropBack()">
                    {{ navLink.linkTitle }}</a
                  >
                  <div class="menu-links">
                    <template v-for="level2Link in navLink.level2Links">
                      <div
                        class="sub"
                        :id="'sub-' + level2Link.linkId"
                        v-if="level2Link.linkType != 'navTile'"
                      >
                        <h3
                          class="title has-sub"
                          v-if="level2Link.linkType != 'navTile'"
                        >
                          <a v-if="level2Link.url != ''" :href="level2Link.url"
                            >{{ level2Link.linkTitle }}
                          </a>
                          <span
                            v-on:click="subOpen($event)"
                            :data-sub="'sub-' + level2Link.linkId"
                            >{{ level2Link.linkTitle }}
                          </span>
                        </h3>
                        <!-- LEVEL 3 -->
                        <ul class="list">
                          <li v-for="level3Link in level2Link.level3Links">
                            <a :href="level3Link.url">{{
                              level3Link.linkTitle
                            }}</a>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </div>
                  <!-- .menu-links -->
                  <div class="menu-boxes">
                    <template v-for="level2Link in navLink.level2Links">
                      <a
                        v-if="level2Link.linkType == 'navTile'"
                        :href="level2Link.url"
                        class="menu-box"
                      >
                        <img
                          v-if="level2Link.imgUrl"
                          :src="
                            level2Link.imgUrl.url.replace(
                              'upload',
                              'upload/w_400/f_auto,q_auto'
                            )
                          "
                          :alt="level2Link.imgUrl.filename"
                          class="img-fluid"
                        />
                        <h1 class="display-7">
                          {{ level2Link.linkTitle }}
                        </h1>
                      </a>
                      <!-- .menu-box -->
                    </template>
                  </div>
                  <!-- .menu-boxes -->
                </div>
                <!-- .drop-menu -->
              </template>
            </div>
            <!-- .level-2 -->
          </nav>
        </div>
        <!--.col-->
      </div>
      <!--.row-->
    </div>
    <!--.containerfluid-->
  </div>
</template>

<script src="./ctrl-top-navigation.js"></script>
